const base = '/users';

const UsersApi = {
  base,
  me: base + '/me'
};

export default UsersApi;
